// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  padding: 0px;
}

.contactUs_page form button {
  background: #264ec8;
  border-radius: 25px;
  padding: 12px 60px;
}

.contactUs_page form label {
  color: #000;
}

.contactUs_page .contactP1 h2 {
  font-size: var(--f45);
  font-weight: 700;
  color: var(--dBlue);
  text-align: left !important;
}

.contactUs_page .contactP1 h2 span {
  color: var(--dPink);
}

/* .card-title {
  margin-top: 20px;
} */
.card_envalop,
.card_phone {
  border: 2px solid #c3c5f8;
  padding: 0px 20px 40px;
}

.card_envalop div,
.card_phone div {
  display: block;
  margin: 0 auto;
  padding: 40px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background: #f9f9fe;
  border: 2px solid #c3c5f8;
  border-radius: 50%;
  text-align: center;
  margin-top: -50px;
}

.card_phone div svg {
  transform: rotate(105deg);
  color: #ff5685;
}

.contactUs_page svg,
.connect svg,
.map_card svg {
  color: #ff5685;
}

/* .card_phone .card-title,
.card_envalop .card-title {
  color: var(--dBlue);
  font-size: var(--sHsize);
  text-transform: uppercase;
  font-weight: 700;
} */
.card_phone .card-text,
.card_envalop .card-text {
  padding-top: 20px;
}
.card_phone .card-title,
.card_envalop .card-title {
  color: var(--dBlue);
  font-size: 24px;
  font-weight: 700;
  margin-top: 20px;
}

.map_card {
  display: flex;
  flex-direction: row;
}

.map-text,
.map-title {
  text-align: left;
  margin-left: 20px;
}

.map_container h2 {
  font-size: var(--f45);
  font-weight: 700;
  color: var(--dBlue);
  margin-bottom: 40px;
}

.map_container h2 span {
  color: var(--dPink);
}

.map-title {
  font-size: var(--f20);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--dBlue);
}

.connect {
  background: rgb(195 197 248 / 10%);
}

@media (max-width: 576px) {
  .custom-contact-form form {
    padding: 50px 20px;
  }

  .contact_us h2 {
    font-size: 36px;
  }

  .card_phone {
    margin-top: 70px;
  }

  .map_card {
    margin-bottom: 20px;
  }

  .map_card svg {
    height: 50px;
    width: auto;
  }

  .map-text {
    font-size: var(--pSize);
  }
  .map_container h2 {
    margin-bottom: 20px;
  }
  .card_envalop div,
  .card_phone div {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactUsPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;GAEG;AACH;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,aAAa;EACb,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;;GAMG;AACH;;EAEE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,aAAa;EACf;AACF","sourcesContent":["form {\r\n  padding: 0px;\r\n}\r\n\r\n.contactUs_page form button {\r\n  background: #264ec8;\r\n  border-radius: 25px;\r\n  padding: 12px 60px;\r\n}\r\n\r\n.contactUs_page form label {\r\n  color: #000;\r\n}\r\n\r\n.contactUs_page .contactP1 h2 {\r\n  font-size: var(--f45);\r\n  font-weight: 700;\r\n  color: var(--dBlue);\r\n  text-align: left !important;\r\n}\r\n\r\n.contactUs_page .contactP1 h2 span {\r\n  color: var(--dPink);\r\n}\r\n\r\n/* .card-title {\r\n  margin-top: 20px;\r\n} */\r\n.card_envalop,\r\n.card_phone {\r\n  border: 2px solid #c3c5f8;\r\n  padding: 0px 20px 40px;\r\n}\r\n\r\n.card_envalop div,\r\n.card_phone div {\r\n  display: block;\r\n  margin: 0 auto;\r\n  padding: 40px;\r\n  width: fit-content;\r\n  background: #f9f9fe;\r\n  border: 2px solid #c3c5f8;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  margin-top: -50px;\r\n}\r\n\r\n.card_phone div svg {\r\n  transform: rotate(105deg);\r\n  color: #ff5685;\r\n}\r\n\r\n.contactUs_page svg,\r\n.connect svg,\r\n.map_card svg {\r\n  color: #ff5685;\r\n}\r\n\r\n/* .card_phone .card-title,\r\n.card_envalop .card-title {\r\n  color: var(--dBlue);\r\n  font-size: var(--sHsize);\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n} */\r\n.card_phone .card-text,\r\n.card_envalop .card-text {\r\n  padding-top: 20px;\r\n}\r\n.card_phone .card-title,\r\n.card_envalop .card-title {\r\n  color: var(--dBlue);\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  margin-top: 20px;\r\n}\r\n\r\n.map_card {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.map-text,\r\n.map-title {\r\n  text-align: left;\r\n  margin-left: 20px;\r\n}\r\n\r\n.map_container h2 {\r\n  font-size: var(--f45);\r\n  font-weight: 700;\r\n  color: var(--dBlue);\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.map_container h2 span {\r\n  color: var(--dPink);\r\n}\r\n\r\n.map-title {\r\n  font-size: var(--f20);\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  color: var(--dBlue);\r\n}\r\n\r\n.connect {\r\n  background: rgb(195 197 248 / 10%);\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .custom-contact-form form {\r\n    padding: 50px 20px;\r\n  }\r\n\r\n  .contact_us h2 {\r\n    font-size: 36px;\r\n  }\r\n\r\n  .card_phone {\r\n    margin-top: 70px;\r\n  }\r\n\r\n  .map_card {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .map_card svg {\r\n    height: 50px;\r\n    width: auto;\r\n  }\r\n\r\n  .map-text {\r\n    font-size: var(--pSize);\r\n  }\r\n  .map_container h2 {\r\n    margin-bottom: 20px;\r\n  }\r\n  .card_envalop div,\r\n  .card_phone div {\r\n    padding: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
